import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-800 text-background-50/90">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-compass-3-fill text-xl text-primary-400"></i>
              </div>
              <span className="text-lg font-heading font-semibold text-background-50">
                kaiyun.con
              </span>
            </div>
            <p className="text-sm text-background-50/60 leading-relaxed">
              kaiyun.con 是您寻找开云平台的重要参考入口，提供导航、注册登录指引及常见问题解答。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">首页</Link>
              <Link to="/category/pingtai-daohang" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">分类浏览</Link>
              <Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">关于我们</Link>
              <Link to="/article/kaiyun-guanfang-rukou-zhengque-dizhi" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">官方入口汇总</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/category/pingtai-daohang" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">平台导航</Link>
              <Link to="/category/zhuce-denglu" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">注册登录</Link>
              <Link to="/category/shiyong-zhinan" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">使用指南</Link>
              <Link to="/category/anquan-fanghu" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">安全防护</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系方式</h4>
            <div className="flex flex-col gap-2.5 text-sm text-background-50/60">
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-sm"></i>
                </div>
                <span>contact@kaiyun.con</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-map-pin-line text-sm"></i>
                </div>
                <span>中国 · 在线服务</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-50/50">
              © {currentYear} kaiyun.con 官方导航入口。本站为第三方导航信息聚合平台，非开云官方网站。开云相关商标归其各自所有者所有。
            </p>
            <div className="flex items-center gap-4 text-xs text-background-50/50">
              <span>Last-modified: 2026-08-08</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}